module.exports = __webpack_public_path__ + "img/kr-product-title-img-1.4036d49.png";